import LinearProgress from '@material-ui/core/LinearProgress';
import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import EnvioDNAForm from './admin/pages/formulario/EnvioDNAForm';
import Formulario from './admin/pages/formulario/Formulario';
import FormularioList from './admin/pages/formulario/FormularioList';
import FormularioView from './admin/pages/formulario/FormularioView';
import ImportadoresList from './admin/pages/formulario/ImportadoresList';
import PerfilEditForm from './admin/pages/formulario/PerfilEditForm';
import PersonasList from './admin/pages/formulario/PersonasList';
import ImportadorEditForm from './admin/pages/formulario/importador/ImportadorEditForm';
import PersonaEditForm from './admin/pages/formulario/persona/PersonaEditForm';

const RedirectComponent = () => {
  const [keycloak] = useKeycloak();
  const gruposList = keycloak.tokenParsed.groups || [];
  const esOperaciones = gruposList.includes('GR_EXPORTAFACIL_OPERACIONES');

  let to = '';
  if (esOperaciones) {
    to = '/enviar-tees';
  } else {
    to = '/formularios';
  }

  return <Redirect to={to} />;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [keycloak] = useKeycloak();
  return (
    <Route
      {...rest}
      render={
        Component
          ? props =>
              keycloak && keycloak.authenticated ? (
                <Component {...props} />
              ) : (
                <LinearProgress />
              )
          : undefined
      }
    />
  );
};

const AppRoutes = () => {
  return (
    <Switch>
      <PrivateRoute path="/formulario" component={Formulario} />
      <PrivateRoute path="/formulario-view/:id" component={FormularioView} />
      <PrivateRoute path="/enviar-tees" component={EnvioDNAForm} />
      <PrivateRoute path="/formularios" component={FormularioList} />
      <PrivateRoute path="/perfil" component={PerfilEditForm} />
      <PrivateRoute path="/personas/edit/:id?" component={PersonaEditForm} />
      <PrivateRoute path="/personas" component={PersonasList} />
      <PrivateRoute
        path="/importadores/edit/:id?"
        component={ImportadorEditForm}
      />
      <PrivateRoute path="/importadores" component={ImportadoresList} />
      <Route exact path="/">
        <RedirectComponent />
      </Route>
      <Redirect to="/404" />
    </Switch>
  );
};

const Router = () => {
  return (
    <React.Suspense fallback={<LinearProgress />}>
      <AppRoutes />
    </React.Suspense>
  );
};

export { PrivateRoute };

export default Router;
